import React from 'react';
import { ToggleIndicatorContainer, ToggleIndicatorVariant, ToggleIndicatorValue } from './toggleIndicator.styles';

type ToggleIndicatorValue = {
  id: string;
  label: string;
};

type ToggleIndicatorProps = {
  values: ToggleIndicatorValue[];
  activeValue: string;
  variant?: ToggleIndicatorVariant;
};

const ToggleIndicator: React.FC<ToggleIndicatorProps> = ({ values, activeValue, variant = 'neutral' }) => {
  return (
    <ToggleIndicatorContainer>
      {values.map((value, i) => {
        return (
          <ToggleIndicatorValue key={i} variant={variant} isActive={value.id === activeValue}>
            {value.label}
          </ToggleIndicatorValue>
        );
      })}
    </ToggleIndicatorContainer>
  );
};

export default ToggleIndicator;
